
export default class CovidEntity {
    id=""
    value=""
    date=new Date()
    covid={}
    token=""
    latitude=""
    longitude=""
}




// WEBPACK FOOTER //
// ./src/model/CovidTracer.js